<div class="player-panel">
    <group-profile-image [images]="profileImages()"/>
    <div class="player-info">
        <div class='player-name'>{{ team().name }}</div>
        <div>{{ players() }}</div>
        <div [hidden]="!team().playingHandicap">Handicap {{ team().playingHandicap }}</div>
    </div>
    <div class="flex-spacer"></div>
    <div *ngFor="let total of totals(); trackBy: trackByMethod">
        <total-score [total]="total"/>
    </div>
</div>

